import { useIntl } from "react-intl";

import { getPlanType } from "./plan-type";
import { formatCurrency } from "./utils";

interface PlanBadgeProps {
  accountName: string;
  balance?: number;
  currency: string;
}

const PlanBadge: React.FC<PlanBadgeProps> = ({
  accountName,
  balance,
  currency,
}) => {
  const intl = useIntl();
  const planType = getPlanType(accountName);
  const planBalance = formatCurrency(balance, intl, currency);

  return (
    <div className="flex h-6 items-center justify-center gap-1 rounded-full bg-gray-02/80 pl-1 pr-2">
      <span className="flex h-5 w-5 items-center justify-center rounded-full bg-gray-03/80 text-[10px] font-medium leading-none text-white">
        {planType}
      </span>
      <span className="font-body text-sm leading-none text-gray-03">
        {planBalance}
      </span>
    </div>
  );
};

export default PlanBadge;
